var $2d999353ca652e34$exports = {};
$2d999353ca652e34$exports = {
  "Clear search": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u0448\u0443\u043A"
};
export { $2d999353ca652e34$exports as default };